import React, { useState } from 'react';
import { useProtectedObjectUrl, type DocumentKind } from '@/lib/file-urls';

/**
 * A picture that lives in private storage, shown through KrewUp: its bytes are requested from the backend (which checks the person's access on every
 * request) and displayed from a local blob. While it loads, or when it can't be shown (access gone, file missing), `fallback` stays -- there is no
 * Storage link in the page, so nothing to expire or leak.
 */
export function ProtectedImage({ kind, id, alt, className, fallback = null }: { kind: DocumentKind; id: string | null | undefined; alt: string; className?: string; fallback?: React.ReactNode }) {
  const file = useProtectedObjectUrl(kind, id);
  const [broken, setBroken] = useState(false);
  if (file.status === 'ready' && !broken) return <img src={file.url} alt={alt} className={className} onError={() => setBroken(true)} />;
  return <>{fallback}</>;
}
